export const getProduct = async (handle) => (await fetch(`/products/${handle}.js`)).json();

export default {
  getProduct,
};
